import { useMediaQuery } from 'usehooks-ts'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export interface BannerItemProps {
  title?: string | null;
  desc?: string | null;
  buttonLink?: string;
  buttonText?: string;
  imageDesktop?: string | null;
  imageMobile?: string | null;
  openInNewTab?: boolean;
}

export default function BannerItem (props: BannerItemProps) {
  const {
    title,
    desc,
    buttonLink,
    buttonText,
    imageMobile,
    imageDesktop,
    openInNewTab
  } = props
  const isTablet = useMediaQuery('(max-width: 991px)')

  return (
    <div className={styles.card}>
      <div className={styles.card__imageWrapper}>
        {!isTablet && (
          <img
            className={styles.card__bg}
            src={imageDesktop as string}
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
        )}
        {isTablet && (
          <img
            className={styles.card__bg}
            src={imageMobile ? (imageMobile as string) : (imageDesktop as string)}
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
        )}
        {buttonLink && !isTablet && (
          <a 
            href={buttonLink} 
            target={openInNewTab ? '_blank' : '_self'}
            className={styles.card__imageLink}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1
            }}
            aria-label="Перейти по ссылке баннера"
          />
        )}
      </div>

      {title && !isTablet && <h3 className={styles.card__title}>{title}</h3>}
      {desc && <p className={styles.card__desc}>{desc}</p>}
      {buttonLink && buttonText && !isTablet && (
        <Button
          className={styles.card__button}
          to={buttonLink}
          size={isTablet ? 'small' : 'large'}
          target={openInNewTab ? '_blank' : '_self'}
        >
          {buttonText}
        </Button>
      )}
    </div>
  )
}
